<button [type]="type" [disabled]="disabled" (click)="onClick()" 
    [style.backgroundColor]="bgcolor">
    <ng-container *ngIf="context !== 'none'">
        <img *ngIf="context === 'default'" class="action-button" src="assets/images/add-icon.svg" alt="add" />
        <img *ngIf="context === 'upload'" class="action-button" src="assets/images/Buttons/export-button.svg"
            alt="upload" />
    </ng-container>
    {{ label }}
</button>